import { EditCaseContext } from './types';
import { PaymentType } from '../submitCase/selectPaymentType';
import { needsFileUpload } from '../../util/case';

export const hasCase = (context: EditCaseContext) => !!context.case;

export const canEditCaseAutoLoadToEnterInfo = (context: EditCaseContext, event?: any) => {
  const caseType = context.caseType;
  return !!caseType;
};

export const canEditCaseAutoLoadToSelectPaymentType = (context: EditCaseContext, event?: any) => {
  const c = event?.data?.case ?? context.case;
  return !!c?.sites && c.sites.length > 0;
};

export const canEditCaseAutoLoadToPayment = (context: EditCaseContext, event?: any) => {
  const c = event?.data?.case ?? context.case;
  const draft = event?.data?.draft;
  const validDraft = draft?.caseId === context.caseId ? draft : null;
  const paymentType = validDraft?.paymentType ?? context.paymentType;

  return (
    !!c?.sites &&
    c.sites.length > 0 &&
    !!paymentType
  );
};

export const canEditCaseAutoLoadToCheckout = (context: EditCaseContext, event?: any) => {
  const c = event?.data?.case ?? context.case;
  const draft = event?.data?.draft;
  const validDraft = draft?.caseId === context.caseId ? draft : null;

  const selectedPaymentMethod = validDraft?.selectedPaymentMethod ??
                                 event?.data?.selectedPaymentMethod ??
                                 context.selectedPaymentMethod;
  const paymentType = validDraft?.paymentType ?? context.paymentType;
  const selectedInvoiceAccountUid = validDraft?.selectedInvoiceAccountUid ??
                                     context.selectedInvoiceAccountUid;

  console.log('[EditCase canAutoLoadToCheckout] Evaluating:', {
    hasSites: !!c?.sites && c.sites.length > 0,
    sitesLength: c?.sites?.length,
    hasPaymentType: !!paymentType,
    paymentType,
    hasSelectedPaymentMethod: !!selectedPaymentMethod,
    selectedPaymentMethod,
    hasSelectedInvoiceAccountUid: !!selectedInvoiceAccountUid,
    selectedInvoiceAccountUid,
    fromDraft: !!validDraft,
    fromEventData: {
      selectedPaymentMethod: event?.data?.selectedPaymentMethod,
      hasDraft: !!event?.data?.draft,
      draftCaseId: event?.data?.draft?.caseId,
      contextCaseId: context.caseId,
    },
    fromContext: {
      selectedPaymentMethod: context.selectedPaymentMethod,
      paymentType: context.paymentType,
    },
  });

  const result = (
    !!c?.sites &&
    c.sites.length > 0 &&
    !!paymentType &&
    (paymentType === PaymentType.INVOICE
      ? !!selectedInvoiceAccountUid
      : !!selectedPaymentMethod)
  );

  console.log('[EditCase canAutoLoadToCheckout] Result:', result);
  return result;
};

export const doesNotNeedUpload = (context: EditCaseContext, event?: any): boolean => {
  const caseInfo = event?.caseInfo || context.caseInfo;
  return !caseInfo?.sites || !needsFileUpload(caseInfo.sites);
};

export * from '../submitCase/guards';
